var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.toestemmingHo
        ? [
            _c("div", { staticClass: "mb-2" }, [
              !_vm.hasAny(_vm.tewerkstellingen)
                ? _c("span", [_vm._v("Geen tewerkstellingen")])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm._l(_vm.tewerkstellingen, function(tew, index) {
              return [
                _c(
                  "div",
                  { key: "tew-binnen-ond-list-" + index },
                  [
                    !_vm.isOnbezoldigdeOnderbreking(tew)
                      ? [
                          _c("list-item", {
                            attrs: {
                              icon: "info-circle",
                              text: _vm.statusStringForOnderbreking(tew),
                              "text-class": _vm.textClassForOnderbrekingStatus(
                                tew
                              ),
                              title: "Status"
                            }
                          }),
                          _vm._v(" "),
                          _c("list-item", {
                            attrs: {
                              icon: "calendar",
                              text: tew.begindatum,
                              title: "Begindatum"
                            }
                          }),
                          _vm._v(" "),
                          _c("list-item", {
                            attrs: {
                              icon: "calendar",
                              text: tew.einddatum,
                              title: "Einddatum"
                            }
                          }),
                          _vm._v(" "),
                          _c("list-item", {
                            attrs: {
                              icon: "id-card",
                              text: tew.functie,
                              title: "Functie"
                            }
                          }),
                          _vm._v(" "),
                          _c("list-item", {
                            attrs: {
                              icon: "pen",
                              text: tew.motivering,
                              title: "Motivering"
                            }
                          }),
                          _vm._v(" "),
                          _c("list-item", {
                            attrs: {
                              icon: "building",
                              text: tew.werkgever,
                              title: "Werkgever"
                            }
                          }),
                          _vm._v(" "),
                          _vm._l(tew.tewerkstellingsFiles, function(
                            tewFile,
                            index
                          ) {
                            return _c("list-item-file", {
                              key: "tew-file-" + index,
                              attrs: {
                                icon: "file-alt",
                                file: tewFile,
                                title: "Tewerkstellingsattest " + (index + 1)
                              }
                            })
                          })
                        ]
                      : [
                          _c("list-item", {
                            attrs: {
                              icon: "info-circle",
                              text: _vm.statusStringForOnderbreking(tew),
                              "text-class": _vm.textClassForOnderbrekingStatus(
                                tew
                              ),
                              title: "Status"
                            }
                          }),
                          _vm._v(" "),
                          _c("list-item", {
                            attrs: {
                              icon: "calendar",
                              text: tew.begindatum,
                              title: "Begindatum"
                            }
                          }),
                          _vm._v(" "),
                          _c("list-item", {
                            attrs: {
                              icon: "calendar",
                              text: tew.einddatum,
                              title: "Einddatum"
                            }
                          }),
                          _vm._v(" "),
                          _c("list-item", {
                            attrs: {
                              icon: "info-circle",
                              text: tew.soortOnderbreking
                                ? tew.soortOnderbreking
                                : "",
                              title: "Soort onderbreking"
                            }
                          })
                        ]
                  ],
                  2
                )
              ]
            })
          ]
        : [
            _c("div", { staticClass: "mb-2" }, [
              _c(
                "span",
                { staticClass: "text-success" },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: ["far", "check"] }
                  }),
                  _vm._v(
                    " U\n        gaf toestemming om uw gegevens op te vragen bij het department."
                  )
                ],
                1
              )
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }